var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions/promoCode/promocodeAction';
import { CHANGE_LOCALE } from '../../actions/locale';
var initialState = {
    error: undefined,
    success: undefined
};
export default function promoCode(state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case Actions.SUCCESS_FETCH_PROMOCODE_ACTIVATE:
            if (action.data.Result === 0) {
                return __assign(__assign({}, state), { error: undefined, success: true });
            }
            else if (action.data.Error !== undefined) {
                return __assign(__assign({}, state), { error: action.data.Error, success: undefined });
            }
            else {
                return __assign(__assign({}, state), { error: "default", success: undefined });
            }
        case Actions.FAILURE_FETCH_PROMOCODE_ACTIVATE:
            return __assign(__assign({}, state), { error: "default", success: undefined });
        case Actions.FETCH_PROMOCODE_ACTIVATE:
            return __assign(__assign({}, state), { error: undefined, success: undefined });
        case CHANGE_LOCALE:
            return __assign(__assign({}, state), { error: undefined, success: undefined });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/promo-code/promocodeReducer.js